import './App.css';
import { Route,Routes } from 'react-router-dom';
import Nabvar from './components/Nabvar.tsx';
import Home from './pages/Home.tsx';
import MisionVision from './pages/MisionVision.tsx';
import Historia from './pages/Historia.tsx';
import Actividades from './pages/Actividades.tsx';
import Personal from './pages/Personal.tsx';
import Logros from './pages/Logros.tsx';
import Normas from './pages/Normas.tsx';
import Footer from './components/Footer.tsx';
import Valores from './pages/Valores.tsx';
import ZonasTuristicas from './pages/ZonasTuristicas.tsx';
function App() {
  return (
    <>
    <Nabvar/>
    <Routes>
      <Route path="/" element={<Home/>} />
      <Route path="/historia" element={<Historia/>} />
      <Route path="/mision" element={<MisionVision/>} />
      <Route path="/actividades" element={<Actividades/>} />
      <Route path="/personal" element={<Personal/>} />
      <Route path="/logros" element={<Logros/>} />
      <Route path="/normas" element={<Normas/>} />
      <Route path="/valores" element={<Valores/>} />
      <Route path="/turismo" element={<ZonasTuristicas/>} />
    </Routes>
    <Footer/>
    </>
  );
}

export default App;
